import { Text } from '@chakra-ui/react';

import { ConfirmModal } from '@/components/ui/modal';

type PasswordChangeCancelModalProps = {
  isPasswordChangeCancelModalOpen: boolean;
  onPasswordChangeCancelModalClose: () => void;
  handleCancelConfirm: () => void;
};

export const PasswordChangeCancelModal = (
  props: PasswordChangeCancelModalProps,
) => {
  console.info('password-change-cancel-modal.tsx_1');

  const {
    isPasswordChangeCancelModalOpen,
    onPasswordChangeCancelModalClose,
    handleCancelConfirm,
  } = props;

  return (
    <ConfirmModal
      isOpen={isPasswordChangeCancelModalOpen}
      onClose={onPasswordChangeCancelModalClose}
      title=""
      content={<Text>パスワード変更をキャンセルしますか？</Text>}
      buttonColorScheme="red"
      headerColor="white"
      primary={{
        text: 'キャンセル',
        action: handleCancelConfirm,
      }}
      secondary={{
        text: '継続する',
        action: onPasswordChangeCancelModalClose,
      }}
    />
  );
};
